module.exports = __webpack_public_path__ + "static/img/es-ct.e5d7fd1b.svg";